module.exports = __webpack_public_path__ + "img/icon_heart_full.7c0d4835.svg";